const FORMAT_REGEX = new RegExp("{-?[0-9]+}", "g");

type ConcatStringsReturnType = (delimitter?: string) => string;
export const concatStrings = (...args: string[]): ConcatStringsReturnType => {
    return (delimitter = " "): string => args.join(delimitter);
};

export function format(str: string, ...args: string[]): string {
    return str.replace(FORMAT_REGEX, (item) => {
        const intVal = parseInt(item.substring(1, item.length - 1), 10);
        let replace;
        if (intVal >= 0) {
            replace = args[intVal];
        } else if (intVal === -1) {
            replace = "{";
        } else if (intVal === -2) {
            replace = "}";
        } else {
            replace = "";
        }
        return replace;
    });
}

export function safeJsonParse<T>(str: string, defaultValue?: T, handleError?: (err: unknown) => void): T | undefined {
    try {
        return JSON.parse(str);
    } catch (err) {
        if (typeof handleError === "function") {
            handleError(err);
        }
        return defaultValue;
    }
}

export function capitalizeFirstLetter(string = ""): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Convert a string to title case
 * @param [string] - The string to convert to title case.
 * @returns The string with the first letter of each word capitalized.
 */
export function convertToTitleCase(string = ""): string {
    return string
        .toLowerCase()
        .split(" ")
        .map((word) => capitalizeFirstLetter(word))
        .join(" ");
}

/**
 * Return formatted string with replacing all the instance occuring in string
 * @param {string} str String on which to perform operation
 * @param {string} toFind String/pattern which need to be replaced
 * @param {string} toReplace String/pattern to be replace by
 */
export function replaceAllOccurence(str = "", toFind: string, toReplace: string): string {
    return str.replace(new RegExp(toFind, "g"), toReplace);
}
